import type { ReactNode } from "react";
import type { OrderType } from "@/features/orders/types";
import { useContractorPreview } from "@/features/orders/contractorPreview";
import { TechnicalProjectTab } from "./TechnicalProjectTab";
import { KosztorysTab } from "./KosztorysTab";

// Subcontractor-facing design-stage panel embedded on an Order page (analogous to the WPW
// handover panel). The order's type maps 1:1 to its design stage (a stage order-link is created
// atomically with order_type), so we mount exactly the matching tab — ze_opracowanie → Projekt
// techniczny, ze_kosztorys → Kosztorys — and nothing (no request) for any other order. This
// replaces the old "fetch by order and self-hide on 404" approach, which fired a wasted
// by-order request on every order page.
export function DesignStageOrderPanel({ orderId, orderType }: { orderId: string; orderType: OrderType }) {
  // „Widok podwykonawcy" (GK): zakładka renderuje się jak u wykonawcy (flagi przeliczone w
  // previewDesignStage), a WSZYSTKIE jej kontrolki są wyłączone natywnie — fieldset[disabled]
  // gasi każdy przycisk i input w środku, więc nowa akcja w zakładce nie ożyje w podglądzie.
  const { isPreview } = useContractorPreview();
  let tab: ReactNode = null;
  if (orderType === "ze_opracowanie") tab = <TechnicalProjectTab orderId={orderId} />;
  else if (orderType === "ze_kosztorys") tab = <KosztorysTab orderId={orderId} />;
  if (tab === null) return null;
  if (!isPreview) return tab;
  return (
    <fieldset disabled className="contents min-w-0 border-0 p-0 m-0" title="Podgląd — akcje niedostępne">
      {tab}
    </fieldset>
  );
}
